<template>
  <div>
    <transition name="fade" mode="out-in">
      <div v-if="page === 'doctor-list'" class="page-doctor-list">
        <div>list</div>
        <button @click="toPageSelectSlot">next</button>
      </div>
    </transition>
    <transition name="fade" mode="out-in">
      <div v-if="page === 'select-slot' " class="page-select-slot">
        <div>slot</div>
        <button @click="toPageDoctorList">back</button>
        <button @click="toPageCheck">next</button>
      </div>
    </transition>
    <transition name="fade" mode="out-in">
      <div v-if="page === 'check'" class="page-check">
        <div>check</div>
        <button @click="toPageSelectSlot">back</button>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  data: () => ({
    page: 'doctor-list'
  }),
  methods: {
    toPageDoctorList(page) {
      this.page = 'doctor-list';
    },
    toPageSelectSlot(page) {
      this.page = 'select-slot';
    },
    toPageCheck(page) {
      this.page = 'check';
    }
  }
};
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
  opacity: 0;
}
</style>